// extracted by mini-css-extract-plugin
export default {"navBox":"index_navBox_cHusp","nav":"index_nav_SV8MS","firstNav":"index_firstNav_QqEqA"};